"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.describedPersonalDetails = void 0;

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var describedPersonalDetails = {
  businessTitle: _stencilReactDesc.PropTypes.string.description('Business title of the displayed employee.'),
  businessTitleHiddenText: _stencilReactDesc.PropTypes.string.description('Hidden label for the business title.'),
  level: _stencilReactDesc.PropTypes.number.description('Job level of the displayed employee.'),
  departmentName: _stencilReactDesc.PropTypes.string.description('Department name where the displayed employee works in.'),
  departmentId: _stencilReactDesc.PropTypes.string.description('Department id where the displayed employee works in.'),
  departmentHiddenText: _stencilReactDesc.PropTypes.string.description('Hidden label for the department.'),
  city: _stencilReactDesc.PropTypes.string.description('City where the displayed employee works.'),
  country: _stencilReactDesc.PropTypes.string.description('Country where the displayed employee works.'),
  locationHiddenText: _stencilReactDesc.PropTypes.string.description('Hidden label for the location.')
};
exports.describedPersonalDetails = describedPersonalDetails;